 export const dummyProducts = [
  {
    id: 1,
    name: "Hippie Trail",
    author: "Auteur : Elléa Bird",
    price: 19.99,
    photo: "/img/1.jpg",
    resume: "Séverine est née en Grèce en 1973, et de longues années se sont écoulées avant qu’elle ne découvre la véritable histoire de sa naissance. Ce roman autobiographique, souvent très drôle et parfois dramatique, retrace son enquête auprès des protagonistes d’un voyage en 4L jusqu’en Afghanistan, sur la célèbre Hippie Trail. Jusqu’à ce que tout dérape… Une aventure pas très glorieuse, souvent drôle, qui désacralise le voyage initiatique des seventies. "
  },
  {
    id: 2,
    name: "L'attaque des Titans T4",
    author: "Auteur : Hajime Isayama",
    price: 14.99,
    photo: "/img/2.jpg",
    resume: "Alors que le Grand Terrassement commence, piétinant maintes victimes, Eren réaffirme son choix de continuer son avancée... "
  },
  {
    id: 3,
    name: "Orcs et Gobelins",
    author: "Auteur : Jean-Luc Istin ",
    price: 14.99,
    photo: "/img/3.jpg",
    resume: "Silence, le plus farouche et le plus redouté des combattants orcs n'est plus que l'ombre de lui-même... Bien décidé à ne pas mourir comme un misérable vieillard, il nous offre un dernier baroud d'honneur et ce sera sanglant ! Silence était autrefois un orc de légende, un des plus grands guerriers des Terres d'Arran, un de ceux que la mort refusait d'emporter à la fin des combats. Aujourd'hui, son visage porte plus de rides que de cicatrices, le vieil orc n'a plus rien d'un tueur, il n'a même plus toute sa tête, il vient pourtant de reprendre les armes. Une ancienne bataille inachevée s'est rappelée à lui et cette fois Silence compte bien la mener à son terme. Quitte à finir sa vieille carcasse, autant le faire avec du sang dans la bouche et les genoux dans la boue plutôt qu'allongé sur un lit"
  },
  {
    id: 4,
    name: "Batman : La cour des hiboux",
    author: "Auteur : Jim lee",
    price: 19.99,
    photo: "/img/4.jpg",
    resume: "Après une longue période d'absence, Bruce Wayne est de retour sous le masque de Batman, à la poursuite d'un mystérieux tueur en série aux allures de hibou, et dont la prochaine cible n'est autre que.Bruce Wayne. Plus il progresse dans son enquête, plus le Chevalier Noir rassemble d'éléments sur les motivations de son ennemi. Il découvre alors une sombre vérité mêlant la famille Wayne aux fondations troubles de Gotham City. "
  },
  {
    id: 5,
    name: "Thorgal : La galère noire",
    author: " de Jean Van Hamme",
    price: 19.99,
    photo: "/img/5.jpg",
    resume: "Une naissance est attendue au foyer de Thorgal et Aaricia. Le valeureux viking n'en fascine pas moins d'autres femmes. L'une d'elles a juré sa perte. Elle l'accuse d'avoir favorisé l'évasion d'un traître. Emmené à bord de la galère noire du prince Véronar, Thorgal est le jouet des caprices sadiques de ce tyran dégénéré! "
  },
  {
    id: 6,
    name: "Zaï Zaï Zaï Zaï",
    author: "Auteur : Fabcaro",
    price: 13.99,
    photo: "/img/6.jpg",
    resume: "Un auteur de bande dessinée, alors qu'il fait ses courses, réalise qu'il n'a pas sa carte de fidélité sur lui. La caissière appelle le vigile, mais quand celui-ci arrive, l'auteur le menace et parvient à s'enfuir. La police est alertée, s'engage alors une traque sans merci, le fugitif traversant la région, en stop et battant la campagne. "
  },
  {
    id: 7,
    name: "Juste derrière moi",
    author: "Auteur : Lisa Gardner",
    price: 9.99,
    photo: "/img/7.jpg",
    resume: "Cela fait longtemps que Sharlah, 13 ans, vit séparée de son frère Telly, depuis le jour fatal où, pour la protéger, il a tué leur père. Sa famille d'accueil, Pierce Quincy  un ex-profiler du FBI et sa femme Rainie, ont su lui redonner confiance dans un cadre sécurisant et aimant. Mais lorsque Pierce est appelé par le shérif de la ville pour un double meurtre commis dans une station-service, le passé de Sharlah resurgit, tel un cauchemar : les caméras de surveillance accusent en effet Telly. Bouleversée, ne pouvant se résigner à sa culpabilité, Sharlah part à la recherche de son frère, traqué par la police... "

  },
  {
    id: 8,
    name: "La machine Ernetti",
    author: "Auteur : Roland Portiche",
    price: 9.99,
    photo: "/img/8.jpg",
    resume: "Mars 1938. Le physicien italien Ettore Majorana disparaît au large de la Sicile. Avec lui, le projet secret sur lequel il travaillait depuis des années. Automne 1955. On retrouve par miracle les notes du physicien disparu. Elles inspirent au père Ernetti une idée folle : construire une machine à voir dans le temps. Un chronoviseur."
  },
  {
    id: 9,
    name: "La nuit du Jabberwock",
    author: "Auteur : Frederic Brown",
    price: 12.99,
    photo: "/img/9.jpg",
    resume: "Doc Stoeger est propriétaire-rédacteur en chef du Carmel City Clarion depuis vingt-trois ans. Exercer un tel métier est un drame dans une bourgade où il ne se passe jamais rien. Il soigne sa morosité au bar du coin, dispute des parties d'échecs avec le jeune Al Grainger et vit par procuration à travers les livres, en particulier l'oeuvre de Lewis Carroll. Ce jeudi soir, jour du bouclage, doc donnerait tout pour une information palpitante, pour qu'il arrive quelque chose."
  },
  {
    id: 10,
    name: "Rivière Maudite",
    author: "Auteur : Preston & Child",
    price: 10.99,
    photo: "/img/10.jpg",
    resume: "La 19e enquête de l'inspecteur Pendergast, du duo de choc Preston & Child (n°1 des ventes du New York Times), le conduit en Floride, aux sources d'une rivière maudite, où des émules du Dr Mengele se livrent à d'inavouables expériences. UNE EFFROYABLE DÉCOUVERTE, DOUBLÉE D'UNE ÉNIGME INSOLUBLE. "
  }
  

];
 
